import { ShieldCheck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { cn } from '@/lib/utils';

interface GuaranteeBadgeProps {
  /** Show the one-line explanation under the badge (pay page). */
  showDetail?: boolean;
  className?: string;
}

// The promise itself lives in the Support FAQ (supportPage.faqs.questions.refund):
// keep the number of days in guarantee.* and that answer in step.
const GuaranteeBadge = ({ showDetail = false, className }: GuaranteeBadgeProps) => {
  const { t } = useTranslation();

  return (
    <div
      className={cn('flex flex-col items-center gap-1 text-center', className)}
      data-testid="guarantee-badge"
    >
      <span
        className="inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm sm:text-base font-semibold font-inter"
        style={{
          color: 'var(--color-cream)',
          border: '1px solid rgba(245,240,232,0.3)',
          backgroundColor: 'rgba(245,240,232,0.06)',
        }}
      >
        <ShieldCheck className="h-5 w-5 shrink-0" aria-hidden="true" />
        {t('guarantee.badge')}
      </span>
      {showDetail && (
        <span className="text-sm font-inter" style={{ color: 'var(--color-cream-muted)' }}>
          {t('guarantee.detail')}
        </span>
      )}
    </div>
  );
};

export default GuaranteeBadge;
